/**
 * 📦 COMPOSANT : sellerie-app/frontend/src\components\Beta\BetaBanner.tsx
 * Ce composant est utilisé dans d'autres pages de l'application
 */

/**
 * Bandeau visible en haut de l'application indiquant la version bêta
 * Permet aux utilisateurs de signaler rapidement des bugs
 */
import React, { useState } from 'react';

interface BetaBannerProps {
  onFeedbackClick?: () => void;
}

const BetaBanner: React.FC<BetaBannerProps> = ({ onFeedbackClick }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-2 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between flex-wrap">
          <div className="flex items-center flex-1">
            <span className="flex p-2 rounded-lg bg-white bg-opacity-20">
              <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </span>
            <p className="ml-3 font-medium text-sm sm:text-base">
              <span className="inline">
                <strong>Version Bêta</strong> • Vos retours sont précieux pour améliorer l'application
              </span>
            </p>
          </div>
          <div className="flex items-center space-x-2 mt-2 sm:mt-0">
            {onFeedbackClick && (
              <button
                onClick={onFeedbackClick}
                className="bg-white text-orange-600 px-4 py-1.5 rounded-md text-sm font-medium hover:bg-orange-50 transition-colors duration-200 shadow-sm"
              >
                📝 Donner mon avis
              </button>
            )}
            <button
              onClick={() => setIsVisible(false)}
              className="text-white hover:text-orange-100 p-1 rounded-md transition-colors"
              aria-label="Fermer le bandeau"
            >
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BetaBanner;
